import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de65d39bc7ade0/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExpertiseStatsSection"] */ "/tmp/8de65d39bc7ade0/components/sections/ExpertiseStatsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/tmp/8de65d39bc7ade0/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de65d39bc7ade0/components/sections/FeaturesCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de65d39bc7ade0/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de65d39bc7ade0/components/sections/InternalLinksSection.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["KioskFeatures"] */ "/tmp/8de65d39bc7ade0/components/sections/KioskFeatures.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QRCaseStudy"] */ "/tmp/8de65d39bc7ade0/components/sections/QRCaseStudy.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SolutionComparison"] */ "/tmp/8de65d39bc7ade0/components/sections/SolutionComparison.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SolutionsGrid"] */ "/tmp/8de65d39bc7ade0/components/sections/SolutionsGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VenuesSlider"] */ "/tmp/8de65d39bc7ade0/components/sections/VenuesSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebshopShowcase"] */ "/tmp/8de65d39bc7ade0/components/sections/WebshopShowcase.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de65d39bc7ade0/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65d39bc7ade0/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65d39bc7ade0/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65d39bc7ade0/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65d39bc7ade0/node_modules/next/dist/client/link.js");
